var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductsIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08984 10.2209V6.6665H15.5898V10.2209C15.5898 12.8666 15.5898 14.1894 14.7763 15.0113C13.9627 15.8332 12.6532 15.8332 10.0343 15.8332H8.64543C6.02649 15.8332 4.71703 15.8332 3.90344 15.0113C3.08984 14.1894 3.08984 12.8666 3.08984 10.2209Z",
    stroke: "#3469E7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08984 6.66683L3.6908 5.38478C4.15689 4.39048 4.38992 3.89333 4.86228 3.61341C5.33464 3.3335 5.94054 3.3335 7.15234 3.3335H11.5273C12.7392 3.3335 13.345 3.3335 13.8174 3.61341C14.2898 3.89333 14.5228 4.39048 14.9888 5.38478L15.5898 6.66683",
    stroke: "#3469E7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08984 9.1665H10.5898",
    stroke: "#3469E7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsIc);
export default __webpack_public_path__ + "static/media/products_ic.09b6f833ea7f9e5bcf2c9199daf599f2.svg";
export { ForwardRef as ReactComponent };